import { Injectable } from '@angular/core';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import firebase from "firebase/compat/app";
import {Observable} from "rxjs";
import {SpecialDay} from "./special-day.model";

@Injectable({
  providedIn: 'root'
})
export class SpecialDayService {
  private collection = this.firestore.collection<SpecialDay>('specialDay');

  constructor(private firestore: AngularFirestore) {}

  create(data: SpecialDay): Promise<any> {
    const payload: SpecialDay = {
      ...data,
      createdAt: firebase.firestore.FieldValue.serverTimestamp() as any,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp() as any,
    };
    return this.collection.add(payload);
  }

  getDataById(id: string): Observable<SpecialDay | undefined> {
    return this.collection.doc<SpecialDay>(id).valueChanges({ idField: 'id' });
  }

  getAll(): Observable<SpecialDay[]> {
    return this.collection.valueChanges({ idField: 'id' });
  }
  update(id: string, data: Partial<SpecialDay>): Promise<void> {
    const payload = {
      ...data,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp()
    };
    return this.collection.doc(id).update(payload);
  }

  deleteRow(id: string): Promise<void> {
    return this.collection.doc(id).delete();
  }
}
